import axios from 'axios';
import DOMPurify from 'dompurify';

export function honoreeErrorCount(errorHonoreeEmailAddress, errorHonoreePostalCode,
  errorHonoreePostalState, errorHonoreeCity, errorHonoreeAddress1,
  errorHonoreeLastName, errorHonoreeFirstName) {
  let errorsToCheck = [
    errorHonoreeEmailAddress.length,
    errorHonoreePostalCode.length,
    errorHonoreePostalState.length,
    errorHonoreeCity.length,
    errorHonoreeAddress1.length,
    errorHonoreeLastName.length,
    errorHonoreeFirstName.length
  ];

  let newErrorsToCheck = errorsToCheck.reduce((a, b) => a + b, 0);
  return newErrorsToCheck;
}

export function questionFailCount(questions) {
  let failCount = 0;
  questions.forEach((q) => {
    if (!q.selectedAnswer || (q.answerAcceptText && q.answerAcceptText !== q.selectedAnswer)) {
      failCount++;
    }
  });

  return failCount;
}

export function navigateForm(e, direction, setIsSecondPart) {
  e.preventDefault();
  if (direction === "next") {
    setIsSecondPart(true);
  } else {
    setIsSecondPart(false);
  }
}

export function showModal(e, setModal, show) {
  if (!e.preventDefault) {
    e.preventDefault();
  }
  setModal(show);
}

export function payeeErrorCount(errorEmailAddress, errorPhone, errorPostalCode,
  errorPostalState, errorCity, errorAddress1, errorLastName, errorFirstName) {
  let errorsToCheck = [
    errorEmailAddress.length, errorPhone.length, errorPostalCode.length,
    errorPostalState.length, errorCity.length, errorAddress1.length,
    errorLastName.length, errorFirstName.length
  ];
  let newErrorsToCheck = errorsToCheck.reduce((a, b) => a + b, 0);
  return newErrorsToCheck;
}

export function createMarkup(message) {
  return { __html: DOMPurify.sanitize(message, { ADD_ATTR: ['target'] }) };
}

export async function submitDonation(e, donationData, setPopupMessage, setPopupTitle,
  setModal, setModalUrl, setWaiting) {
  await axios.post(`/donation`, donationData)
    .then((response) => {
      setWaiting(false);
      if (response.data.success) {
        window.location = response.data.payGovRedirectUrl;
      } else if (response.data.ineligible) {
        setPopupMessage(ineligibleMessage());
        setPopupTitle(`Ineligible Donation`);
        showModal(e, setModal, true);
      }
    })
    .catch((error) => {
      setWaiting(false);
      let errMsg = getXhrErrorMessage(error.response);

      if (errMsg) {
        if (errMsg.includes('Error validating address')) {
          setPopupMessage(`${errMsg}</br></br>Do you wish to submit anyway?`);
          setPopupTitle(`Address Verification`);
        } else {
          setPopupMessage(errMsg);
          setPopupTitle(`Error`);
        }
        showModal(e, setModal, true);
      }
    });
}

export function getXhrErrorMessage(response) {
  if (!response) {
    return null;
  }
  let msg = "";
  if (response.status === 500) {
    msg = "Internal Server Error";
  } else if (response.status === 400) {
    if (response.data.title) {
      msg = response.data.title;
    } else if (response.data.errorText) {
      msg = response.data.errorText;
    } else if (response.data.message) {
      msg = response.data.message;
    } else if (response.data) {
      msg = response.data;
    } else {
      msg = "Bad Request";
    }
  } else {
    msg = "Unknown Error";
  }

  return msg;
}

export function disableInputs(disable) {
  const inputs = document.querySelectorAll('select, input:not([type="radio"]), input[type="radio"]:not([name^="question-"])');
  inputs.forEach(input => {
    input.disabled = disable;
  });
}

export function ineligibleMessage() {
  return `Thank you for your generous offer to support the Wild Horse and Burro Stewardship Program! While this website allows donations of up to $249 per year,
        larger contributions are absolutely welcome. Simply contact our Wild Horse and Burro National Information Center at
        <a href="mailto:${window.config.SiteContactEmail}">${window.config.SiteContactEmail}</a> or ${window.config.SiteContactPhone} to 
        discuss additional giving options. We'll be happy to guide you through any additional paperwork required for larger donations.`;
}